import { Component, OnInit, Inject, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AddCustomerService } from '../add-customer/add-customer.service';
import { environment as ENV } from 'environments/environment';

import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';


@Component({
  selector: 'wl-add-coapplicant',
  templateUrl: './add-coapplicant.component.html',
  styles: [],
  providers: [AddCustomerService]
})
export class AddCoapplicantComponent implements OnInit {


  adminForm: UntypedFormGroup;
  isDataPending: boolean;
  data: any;
  type: any;
  typeText: String;
  placeholder: String;
  public onClose: Subject<boolean>;

  constructor(
    private fb: UntypedFormBuilder,
    private snackbar: MatSnackBar,
    private cust: AddCustomerService,
    private dialog: MatDialog,
    public bsModalRef: BsModalRef,
    // @Inject(MODAL_DIRECTVES)
    // @Inject(MAT_DIALOG_DATA) public data: any,
    private modalService: BsModalService
  ) {
    this.adminForm = this.fb.group({
      custId: ['', Validators.required],
      name: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z ]+')])],
      email: [''],
      mobileNo: [''],
      resAdd: [''],
      offAdd: [''],
      resUnitNo: [''],
      offUnitNo: [''],

    });


    this.data = this.modalService.config.initialState;
    console.log(this.modalService.config.initialState)
    console.log('data', this.data.custId);
    this.type = this.data.type;
    if (this.type === 1) {
      this.typeText = "Co-Applicant";
    } else {
      this.typeText = "Guarantor";
    }
    this.placeholder = ENV.placeHolderSetting.placeholder;
  }

  public onConfirm(): void {
    this.onClose.next(true);
    this.bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this.bsModalRef.hide();
  }
  ngOnInit() {
    this.onClose = new Subject();
    if (this.type === 1) {
      this.cust.getCoAppCount(this.data.custId).subscribe(res => {
        
        console.log("countresp " + JSON.stringify(res));
        if(res.result == "4"){
          this.bsModalRef.hide();
          this.snackbar.open("This Applicant is having Maximun Co-Applicant",'OK',{duration : 5000})
        }else{
          this.adminForm.patchValue({ "custId": this.data.custId + "-CO" + (res.result + 1) });
        }
      })
    } else {
      this.cust.getGuarantorCount(this.data.custId).subscribe(res => {
        console.log("countresp " + JSON.stringify(res));
        if (res) {
          console.log(this.data.custId + "-CO" + (res.result + 1));
          this.adminForm.patchValue({ "custId": this.data.custId + "-GA" + (res.result + 1) });
        }
      })
    }



  }
  onFormSubmit(custData) {
    custData.isRetail = this.data.isRetail;
    console.log("cust dtata ",custData)
    this.isDataPending = true;
    custData.parentId = this.data.custId;
    custData.addedBy = sessionStorage.getItem('wl-admin-id');
    if (this.type === 1) {
      custData.typeId = 1;
    } else {
      custData.typeId = 2;
    }

    console.log("response " + JSON.stringify(custData));

    this.cust.addCustomer(custData).subscribe(res => {
      console.log('Add Res: ', res);
      if (res.success) {
        this.onClose.next(true);
        this.bsModalRef.hide();
        this.isDataPending = false;
        this.snackbar.open('Customer Added Successfully', 'OK', { duration: 2000 });
        this.adminForm.reset();
      } else {
        this.onClose.next(false);
        this.bsModalRef.hide();
        this.isDataPending = false;
        this.snackbar.open(res.message, 'OK', { duration: 2000 });
      }

    })

  }

  // openDialog(type) {
  //   const dialogRef = this.dialog.open(GoogleMapComponent);
  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result) {
  //       console.log('Result Location: ', result);
  //       console.log("type " + type);
  //       if (type === "off") {
  //         this.adminForm.patchValue({ offAdd: result.address });
  //       } else if (type === "res") {
  //         this.adminForm.patchValue({ resAdd: result.address });
  //       }

  //     } else {
  //       console.log('Address: ', 'Address not selected');
  //     }
  //   });
  // }

}
